<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.background.color"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields.background.color" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Title Content</div>
          <div class="group-item mb-5">
            <ckeditor :editor="editor" v-model="fields.titleContent" :config="editorConfig" />
          </div>
        </div>

        <div>
          <div class="label-input">Table Settings</div>
          <div class="group-item mb-5">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="border-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.table.borderColor"
                    @change="handleChangeBorderColor"
                  />
                  <v-text-field v-model="fields.table.borderColor" label="Border Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.table.borderWeight"
                  label="Border Weight"
                  hint="e.g., 1px, 2px"
                  persistent-hint
                />
              </v-col>
              <!-- <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.table.borderSpacingVertical"
                  label="Border Spacing Vertical (px)"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.table.borderSpacingHorizontal"
                  label="Border Spacing Horizontal (px)"
                  type="number"
                />
              </v-col> -->
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.table.colBorder" label="Column Border" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.table.rowBorder" label="Row Border" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Table HTML</div>
          <div class="group-item mb-5">
            <ckeditor :editor="editor" v-model="fields.table.html" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'TableSmallB1',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Table Small B1 Section',
        textColor: '#000000',
        enableAnchor: false,
        padding: {
          top: true,
          bottom: true,
        },
        background: {
          color: '',
        },
        titleContent: `
          <h3 style="text-align:center;">Not All Outdoor Lights Are Created Equal</h3>
          <p style="text-align: center;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti voluptatum ipsum pariatur.</p>
        `,
        table: {
          colBorder: true,
          rowBorder: true,
          borderColor: '#c1c1c1',
          borderSpacingVertical: 0,
          borderSpacingHorizontal: 0,
          borderWeight: '1px',
          html: `
            <table>
              <thead>
                <tr>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
              </tbody>
            </table>
          `,
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTableSmallB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackgroundColor(event) {
      this.fields.background.color = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleChangeBorderColor(event) {
      this.fields.table.borderColor = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
